
export default {
  updateSugKeyword(state, data) {
    state.sugKeyword = data
  },
  updateIsHistory (state, data) {
    state.isHistory = data
  },
  updateSugTypeValue (state, payload = {}) {
    state.sugTypeValue = payload
  },
  updateResultSugType (state, payload = '') {
    state.resultSugType = payload
  },
  updateSugLoading (state, payload = {}) {
    state.sugLoading = payload
  },
  updateSugNameResultData (state, payload = {}) {
    state.sugNameResultData = payload
  },
  updatePageNo(state, payload = {}) {
    state.pageNo = payload
  },
  updateResultLoading (state, payload = {}) {
    state.resultLoading = payload
  },
  updateSugResultList(state, payload = {}) {
    const {list, total, reset} = payload
    state.sugResultList.list = reset ? list : state.sugResultList.list.concat(list)
    state.sugResultList.total = total
  },
  updateSearchStatus(state, data) {
    state.searchStatus = data
  },
  updateVisitInitInfo(state, payload = {}) {
    state.visitInitInfo = payload
  },
  updateRepeatBusinessKeyword(state, data) {
    state.repeatBusinessKeyword = data
  },
  updateRepeatBusinessPageNo(state, payload = {}) {
    state.repeatBusinessPageNo = payload
  },
  updateRepeatBusinessLoading (state, payload = {}) {
    state.repeatBusinessLoading = payload
  },
  updateRepeatBusinessSugList(state, payload = {}) {
    const {list, total, reset} = payload
    state.repeatBusinessSugList.list = reset ? list : state.repeatBusinessSugList.list.concat(list)
    state.repeatBusinessSugList.total = total
  },
}
